export class ForexEnvironment {
  public static getName = () => 'benzinga-forex-quotes';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://www.benzinga.com/'),
  });
}
